/**
 * @file The Column Settings component.
 * @author Heino Lenting
*/
import * as tslib_1 from "tslib";
import { ChangeDetectorRef } from '@angular/core';
import { ColumnBase } from '../../base/columns/column-base/column-base';
import { ColumnProvider } from '../../base/column-provider';
import { ComponentRegistry } from '../../core/component-registry';
import { SettingsValueTypes } from '../helpers/settings-value-types';
var ColumnSettingsComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ColumnSettingsComponent, _super);
    /**
      * Constructs a ColumnStringComponent.
      * @param provider Provides the configuration information for the column.
      */
    function ColumnSettingsComponent(provider, changeDetector) {
        var _this = _super.call(this, provider, changeDetector) || this;
        /**
        * Possible types that can be used in the ng switch
        */
        _this.entityTypes = SettingsValueTypes;
        return _this;
    }
    /**
     * Register this column class for the column provider.
     */
    ColumnSettingsComponent.register = function () {
        ComponentRegistry.register('column', 'settings', ColumnSettingsComponent);
    };
    Object.defineProperty(ColumnSettingsComponent.prototype, "field", {
        get: function () {
            var editor = 'string';
            var name = 'Value';
            var entity = this.provider.entity;
            if (entity) {
                switch (entity['Type']) {
                    case SettingsValueTypes.date:
                        name = 'AsDate';
                        editor = 'date';
                        break;
                    case SettingsValueTypes.integer:
                        name = 'AsInteger';
                        editor = 'number';
                        break;
                }
            }
            return {
                name: name,
                editor: editor
            };
        },
        enumerable: true,
        configurable: true
    });
    return ColumnSettingsComponent;
}(ColumnBase));
export { ColumnSettingsComponent };
